import { createFileRoute } from "@tanstack/react-router";
import AdminLogin from "@/pages/admin/AdminLogin";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/")({
  head: () => adminHead("Admin Login | Hadley Energy Solutions", "Sign in to the Hadley Energy Solutions admin dashboard.", "/admin"),
  component: AdminLogin,
});
